// extracted by mini-css-extract-plugin
var _1 = "t2MI";
export { _1 as "card" }
